
import React, { Component } from 'react';


import './../../../scss/App.scss';

import Crossword from '../gamepage/Crossword';
import InfoBox from './InfoBox';
import PowerPieces from './PowerPieces';
import OverlayManager from '../overlays/OverlayManager';
import CustomKeyboard from './CustomKeyboard';
import RewardAdContainer from '../ads/RewardAdContainer';
import * as Utils from '../../utils/utils';

import { trackingWrapper } from '../../utils/analytics';


class GamePage extends Component {

	constructor(props){
		super(props);

		this.adReward = "";

		this.state = {
			"showVideoAd" : false,
			"videoAdId" : 0,
			"videoAdCallback" : null,
			"hasWon": false
		}

		//

		this.handleVideoOverlayClose = this.handleVideoOverlayClose.bind(this);

		//

		window.ppz.gamePage = this;
	}

	componentDidMount(){
		// tracking
		trackingWrapper('event', 'PPZgame-begin-round', {'event_category':'people-puzzler-game'});

		if(window.ppz.debug || !window.ppz.firstLoad){
			window.ppz.instructionsShown = true;
		}
		else {
			window.ppz.overlayManager.setPanel("instructions");
			window.ppz.firstLoad = false;
		}
	}


	renderVideoOverlay(){
		if(this.state.showVideoAd){
			return(
				<RewardAdContainer 
					showVideoAd={this.state.showVideoAd}
					handleVideoOverlayClose={this.handleVideoOverlayClose} 
					videoId={this.state.videoAdId}
					/>
			);
		}
	}

	hasWon(bool){
		this.setState({
			"hasWon": true
		});
	}

	showVideoAd(reward){
		if(reward === "powerPiece"){
			this.adReward = "powerPiece";
		}
		else if(reward === "unlockPuzzle"){
			this.adReward = "unlockPuzzle";
		}

		//

		if(window.ppz.debug){
			this.handleVideoOverlayClose();
		}
		else {
			this.setState({
				"showVideoAd": true
			});
		}
	}

	handleVideoOverlayClose(){
		this.setState({
			"showVideoAd": false
		});

		if(this.adReward === "powerPiece"){
			// tracking
			trackingWrapper('event', 'PPZgame-reward-power-piece', {'event_category':'people-puzzler-game'});

			window.ppz.powerPieces.unlockAPowerPiece();
		}
		else if(this.adReward === "unlockPuzzle"){
			// tracking
			trackingWrapper('event', 'PPZgame-reward-unlock', {'event_category':'people-puzzler-game'});

			console.log("handleVideoOverlayClose - unlockPuzzle", window.ppz.puzzleToUnlock);
			Utils.unlockPuzzlesSetCookies(window.ppz.puzzleToUnlock.day);
			window.ppz.app.initPuzzleDay(window.ppz.puzzleToUnlock.day);
		}

		// reset vars 
		this.adReward = "";
		window.ppz.puzzleToUnlock = null;

		console.log('handleVideoOverlayClose');
	}

	render(){

		const imageHash = (window.ppz.puzzleData.title + window.ppz.puzzleData.number).replace(/\s/g, "").replace(/[^a-zA-Z0-9 ]/g, '');
		console.log("imageHash", imageHash);

		const leftImageSrc = window.ppz.puzzlePath + window.ppz.config.puzzleData.leftImageFileName;
		const leftImageStyle = {
			"backgroundImage": "url('" + leftImageSrc + "?v=" + imageHash + "')"
		}

		const rightImageSrc = window.ppz.puzzlePath + window.ppz.config.puzzleData.rightImageFileName;
		const rightImageStyle = {
			"backgroundImage": "url('" + rightImageSrc + "?v=" + imageHash + "')"
		}

		const underImageSrc = window.ppz.puzzlePath + window.ppz.config.puzzleData.underPuzzleImageFileName;
		const underImageStyle = {
			"backgroundImage": "url('" + underImageSrc + "?v=" + imageHash + "')"
		}

		return (
			<div id="game">
				<div className="content-grid">
					<div className="leftImage" style={leftImageStyle}></div>
					<div className="puzzleWrapper">
						<div className="category">{this.props.puzzleData.title}</div>
						<div className="underImage" style={underImageStyle}></div>
						<Crossword puzzleData={this.props.puzzleData} hasWon={this.state.hasWon} />
					</div>
					<div className="rightImage" style={rightImageStyle}></div>
					<InfoBox hasWon={this.state.hasWon} />
					<PowerPieces hasWon={this.state.hasWon} />
				</div>
				<CustomKeyboard />
				<OverlayManager />
				{this.renderVideoOverlay()}
			</div>
		);
	}
}

export default GamePage;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/GamePage.js